import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import api from '../services/api';
import './VentaTonelada.css';

const VentaTonelada = () => {
  const [varieties, setVarieties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVariety, setSelectedVariety] = useState(null);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    country: '',
    phone: '',
    quantity: '1',
    quantityUnit: 'kg',
    quality: '',
    message: ''
  });

  useEffect(() => {
    cargarVariedades();
  }, []);

  const cargarVariedades = async () => {
    try {
      setLoading(true);
      // 🔥 CORREGIDO: Usar la tabla cafe_verde
      const response = await api.get('/cafe-verde');
      
      if (response.data && response.data.length > 0) {
        // Mapear los datos de la tabla cafe_verde al formato que necesita el frontend
        const variedadesMapeadas = response.data.map(item => ({
          id: item.id,
          name: item.nombre,
          origin: item.origen || 'México',
          especie: item.especie || 'Arábica',
          altitude: item.altitud || '1,400 - 1,800 msnm',
          profile: item.perfil_taza || 'Por definir',
          humedad: item.humedad || '10-12%',
          stock: item.stock_kg,
          price: 0, // Precio por cotización
          descripcion: item.descripcion || ''
        }));
        setVarieties(variedadesMapeadas);
      } else {
        setVarieties([]);
      }
    } catch (error) {
      console.error('Error cargando variedades:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const cantidadTexto = formData.quantityUnit === 'ton' 
      ? `${formData.quantity} tonelada(s)` 
      : `${formData.quantity} kg`;
    
    let mensaje = `📦 **SOLICITUD DE COTIZACIÓN - CAFÉ VERDE**\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;
    mensaje += `👤 Nombre: ${formData.name}\n`;
    mensaje += `📧 Email: ${formData.email}\n`;
    mensaje += `🏢 Empresa: ${formData.company || 'No especificada'}\n`;
    mensaje += `🌍 País: ${formData.country}\n`;
    mensaje += `📞 Teléfono: ${formData.phone}\n`;
    mensaje += `📦 Cantidad: ${cantidadTexto}\n`;
    mensaje += `⚡ Variedad: ${formData.quality}\n`;
    mensaje += `📝 Mensaje: ${formData.message || 'Sin mensaje adicional'}\n\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
    mensaje += `Un asesor comercial te contactará en máximo 24 horas.\n`;
    mensaje += `¡Gracias por tu interés en Román Valderrábano El Catador!`;

    alert(mensaje);
  };

  const openWhatsApp = (variedad) => {
    const mensaje = `Hola, me interesa información sobre Café Verde: *${variedad.name}*\n\n` +
      `📍 *Origen:* ${variedad.origin}\n` +
      `🌱 *Especie:* ${variedad.especie}\n` +
      `☕ *Taza:* ${variedad.profile}\n` +
      `📊 *Altitud:* ${variedad.altitude}\n` +
      `💧 *Humedad:* ${variedad.humedad}\n\n` +
      `¿Podrían darme más información sobre disponibilidad y precios?`;

    const whatsappUrl = `https://wa.me/527641057461?text=${encodeURIComponent(mensaje)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando variedades de café verde...</p>
      </div>
    );
  }

  return (
    <>
      <SEO 
        title="Café Verde | Venta por Kilo y Tonelada | Román Valderrábano El Catador"
        description="Venta de café verde para tostadores, importadores y productores. Compra desde 1 kg hasta toneladas."
        keywords="café verde, café por kilo, café por tonelada, exportación café mexicano"
        url="https://romanvalderrabanoelcatador.com/venta-tonelada"
      />
      <div className="venta-tonelada-page">
        {/* Hero Section */}
        <section className="venta-hero">
          <div className="venta-hero-content">
            <h1>Café Verde de Especialidad</h1>
            <p>Venta desde 1 kg hasta toneladas · Exportación directa</p>
          </div>
        </section>

        {/* Información Principal */}
        <section className="venta-info-section">
          <div className="venta-container">
            <div className="venta-stats">
              <div className="stat-card">
                <span className="stat-number">1000+</span>
                <span className="stat-label">Toneladas exportadas</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">15+</span>
                <span className="stat-label">Países importadores</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">100%</span>
                <span className="stat-label">Trazabilidad</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">5</span>
                <span className="stat-label">Certificaciones</span>
              </div>
            </div>

            <div className="venta-grid">
              <div className="venta-text">
                <h2>¿Por qué comprar directamente de nuestra finca?</h2>
                <p>
                  En Román Valderrábano El Catador, eliminamos los intermediarios para ofrecerte el mejor café 
                  verde del mercado. Trabajamos directamente con tostadores, importadores y 
                  productores de todo el mundo.
                </p>
                
                <ul className="venta-benefits">
                  <li>Precios competitivos - Hasta 30% menos que el mercado</li>
                  <li>Trazabilidad completa con certificados de origen</li>
                  <li>Perfiles de taza certificados por Q-Graders</li>
                  <li>Documentación de exportación incluida</li>
                  <li>Flexibilidad en volúmenes: desde 1 kg hasta toneladas</li>
                  <li>Envíos a cualquier parte del mundo</li>
                  <li>Certificaciones: Orgánico, Comercio Justo, Rainforest Alliance</li>
                </ul>
              </div>
              
              <div className="venta-image">
                <img 
                  src="https://images.unsplash.com/photo-1461023058943-07fcbe16d735" 
                  alt="Café verde en costales"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Variedades Disponibles */}
        <section className="variedades-section">
          <div className="venta-container">
            <h2>Variedades de Café Verde</h2>
            <p>Seleccionamos los mejores granos de nuestras fincas y productores aliados</p>
            
            {varieties.length === 0 ? (
              <div className="no-products">
                <p>No hay variedades disponibles en este momento. Consulta directamente con nosotros.</p>
                <button 
                  className="btn-primary"
                  onClick={() => openWhatsApp({ name: 'café verde' })}
                >
                  Consultar por WhatsApp
                </button>
              </div>
            ) : (
              <div className="variedades-grid">
                {varieties.map(variety => (
                  <div 
                    key={variety.id} 
                    className={`variedad-card ${selectedVariety === variety.id ? 'selected' : ''}`}
                    onClick={() => setSelectedVariety(variety.id)}
                  >
                    <h3>{variety.name}</h3>
                    
                    <div className="variedad-detalles">
                      <p className="variedad-origen">
                        <strong>📍 Origen:</strong> {variety.origin}
                      </p>
                      <p className="variedad-especie">
                        <strong>🌱 Especie:</strong> {variety.especie}
                      </p>
                      <p className="variedad-perfil">
                        <strong>☕ Taza:</strong> {variety.profile}
                      </p>
                      <p className="variedad-altitud">
                        <strong>📊 Altitud:</strong> {variety.altitude}
                      </p>
                      <p className="variedad-humedad">
                        <strong>💧 Humedad:</strong> {variety.humedad}
                      </p>
                    </div>

                    <button 
                      className="btn-whatsapp"
                      onClick={(e) => {
                        e.stopPropagation();
                        openWhatsApp(variety);
                      }}
                    >
                      📱 Consultar por WhatsApp
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        {/* Proceso de Compra */}
        <section className="proceso-section">
          <div className="venta-container">
            <h2>Proceso de Compra</h2>
            <div className="proceso-steps">
              <div className="step"><div className="step-number">1</div><h4>Contacto Inicial</h4><p>Completa el formulario o escríbenos por WhatsApp</p></div>
              <div className="step"><div className="step-number">2</div><h4>Asesoría Personalizada</h4><p>Te contactamos para entender tu perfil deseado</p></div>
              <div className="step"><div className="step-number">3</div><h4>Envío de Muestras</h4><p>Recibe muestras de 1kg para evaluar calidad</p></div>
              <div className="step"><div className="step-number">4</div><h4>Cotización</h4><p>Recibe precio final según volumen y calidad</p></div>
              <div className="step"><div className="step-number">5</div><h4>Logística y Envío</h4><p>Coordinamos embarque y documentación</p></div>
            </div>
          </div>
        </section>

        {/* Formulario de Contacto Comercial */}
        <section className="contacto-comercial">
          <div className="venta-container">
            <div className="contacto-comercial-grid">
              <div className="contacto-info">
                <h2>Solicita Información</h2>
                <p className="contacto-subtitle">Compra desde 1 kg hasta toneladas. Te responderemos en máximo 24 horas.</p>
                <div className="contacto-metodos">
                  <div className="metodo"><span className="metodo-icon">📞</span><div><h4>WhatsApp Comercial</h4><p>+52 764 105 7461</p><small>Respuesta inmediata</small></div></div>
                  <div className="metodo"><span className="metodo-icon">✉️</span><div><h4>Email</h4><p>ventas@cafeelcatador.com</p></div></div>
                  <div className="metodo"><span className="metodo-icon">💬</span><div><h4>Chat en vivo</h4><p>Disponible 8am - 6pm</p></div></div>
                </div>
                <button className="btn-whatsapp-large" onClick={() => openWhatsApp({ name: 'café verde' })}>📱 Contáctanos por WhatsApp</button>
              </div>
              
              <div className="contacto-form">
                <form onSubmit={handleSubmit}>
                  <div className="form-group"><input type="text" name="name" placeholder="Nombre completo *" value={formData.name} onChange={handleInputChange} required /></div>
                  <div className="form-row">
                    <div className="form-group"><input type="email" name="email" placeholder="Email *" value={formData.email} onChange={handleInputChange} required /></div>
                    <div className="form-group"><input type="text" name="company" placeholder="Empresa" value={formData.company} onChange={handleInputChange} /></div>
                  </div>
                  <div className="form-row">
                    <div className="form-group"><input type="text" name="country" placeholder="País *" value={formData.country} onChange={handleInputChange} required /></div>
                    <div className="form-group"><input type="tel" name="phone" placeholder="Teléfono *" value={formData.phone} onChange={handleInputChange} required /></div>
                  </div>
                  <div className="form-row">
                    <div className="form-group"><input type="number" name="quantity" placeholder="Cantidad" value={formData.quantity} onChange={handleInputChange} min="1" step="0.1" /></div>
                    <div className="form-group"><select name="quantityUnit" value={formData.quantityUnit} onChange={handleInputChange}><option value="kg">Kilogramos (kg)</option><option value="ton">Toneladas</option></select></div>
                  </div>
                  <div className="form-group">
                    <select name="quality" value={formData.quality} onChange={handleInputChange} required>
                      <option value="">Selecciona variedad *</option>
                      {varieties.map(v => (<option key={v.id} value={v.name}>{v.name}</option>))}
                    </select>
                  </div>
                  <div className="form-group"><textarea name="message" placeholder="Requerimientos específicos (opcional)" rows="4" value={formData.message} onChange={handleInputChange}></textarea></div>
                  <button type="submit" className="btn-submit btn-large">Solicitar Información</button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Preguntas Frecuentes */}
        <section className="faq-section">
          <div className="venta-container">
            <h2>Preguntas Frecuentes</h2>
            <div className="faq-grid">
              <div className="faq-item"><h4>¿Cuál es el volumen mínimo de compra?</h4><p>No tenemos volumen mínimo. Puedes comprar desde 1 kilogramo hasta toneladas.</p></div>
              <div className="faq-item"><h4>¿Puedo comprar menos de una tonelada?</h4><p>¡Claro que sí! Aceptamos pedidos desde 1 kg.</p></div>
              <div className="faq-item"><h4>¿Incluyen los costos de envío?</h4><p>Los costos de envío se cotizan por separado según destino y volumen.</p></div>
              <div className="faq-item"><h4>¿Puedo recibir muestras antes de comprar?</h4><p>Sí, enviamos muestras de 1kg.</p></div>
              <div className="faq-item"><h4>¿Qué documentación proporcionan?</h4><p>Certificados de origen, análisis de taza, factura comercial, etc.</p></div>
              <div className="faq-item"><h4>¿Cómo garantizan la consistencia?</h4><p>Cada lote es analizado por nuestro equipo de Q-Graders.</p></div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VentaTonelada;